/**
 * @desc 详情
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.warehouseCost.detail.Params, options?: any) {
  return updateResponse(
    http(URL + `/warehouseCost/detail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
